import { render, staticRenderFns } from "./BCXButtonDropdown.vue?vue&type=template&id=53a4d89a&scoped=true"
import script from "./BCXButtonDropdown.vue?vue&type=script&lang=ts"
export * from "./BCXButtonDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BCXButtonDropdown.vue?vue&type=style&index=0&id=53a4d89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4d89a",
  null
  
)

export default component.exports